import { render, staticRenderFns } from "./ProToast.vue?vue&type=template&id=6473ead3&scoped=true&lang=pug&"
import script from "./ProToast.vue?vue&type=script&lang=js&"
export * from "./ProToast.vue?vue&type=script&lang=js&"
import style0 from "./ProToast.vue?vue&type=style&index=0&id=6473ead3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473ead3",
  null
  
)

export default component.exports